import MeetingRatings from './MeetingRatings'

export default MeetingRatings
